import type { BacklogHttpResponse } from "../contracts/api/BacklogHttpResponse";
import { BacklogApiBaseError } from "./BacklogApiBaseError";
import type { BacklogApiErrorDetail } from "./BacklogApiErrorDetail";
import type { BacklogApiErrorDetailList } from "./BacklogApiErrorDetailList";

export class BacklogApiError extends BacklogApiBaseError {
	protected readonly error_details: BacklogApiErrorDetailList;
	constructor(options: {
		response: BacklogHttpResponse;
		error_details: BacklogApiErrorDetailList;
		message?: string;
	}) {
		super({
			response: options.response,
			message: options.message ?? "BacklogApiError",
		});
		this.error_details = options.error_details;
	}

	getErrors(): BacklogApiErrorDetail[] {
		return this.error_details;
	}
	firstError(): BacklogApiErrorDetail {
		return this.error_details[0];
	}
	toString(): string {
		return this.firstError().toString();
	}
}
